import { render, staticRenderFns } from "./SubjectHistorySlidebar.vue?vue&type=template&id=38cb46b7"
import script from "./SubjectHistorySlidebar.vue?vue&type=script&lang=js"
export * from "./SubjectHistorySlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports